import { useContext } from "react";
import { SummerSchoolResearchContext } from "../contexts/summerSchoolResearchContext";

const useSummerSchoolResearchContext = () =>
  useContext(SummerSchoolResearchContext);

export { useSummerSchoolResearchContext };
